module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_j_normal.39bfb274.png";